import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
export default {
  name: 'breadCrumb',
  components: {},
  data() {
    return {
      breadList: []
    };
  },
  created() {
    this.getBreadCrumb();
  },
  methods: {
    getBreadCrumb() {
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      let home = {
        path: '/index',
        meta: {
          title: '首页'
        }
      };
      if (matched[0].path == '/index') {
        this.breadList = [home];
      } else {
        this.breadList = [home, ...matched];
      }
    }
  },
  watch: {
    $route() {
      this.getBreadCrumb();
    }
  }
};